// extracted by mini-css-extract-plugin
module.exports = {"field":"DeviceMoveStep_field__1JncK","text":"DeviceMoveStep_text__2YKkI"};